import { IVariationCollectionType } from '@pcln/contentful-components'

export default function isContentIVariationCollectionType<T>(
  content: T | IVariationCollectionType | undefined
): content is IVariationCollectionType {
  return (
    content !== undefined &&
    (content as IVariationCollectionType).experimentName != null &&
    (content as IVariationCollectionType).experimentName.trim() !== ''
  )
}
